import React from 'react';
import { LanguageContextProvider } from './LanguageContextProvider';

interface AppContextProviderProps {
    children: React.ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps): React.ReactElement => (
    <LanguageContextProvider>
        {children}
    </LanguageContextProvider>
);
